export default "__VITE_ASSET__Cy8CBD9L__"